import store from './index'

export default {
  getUrl (key, systemConfig) {
    if (systemConfig) return systemConfig.endpoint[key]
    if(!store.state.endpoint.endPointConfig[key]) throw {response: {data: {error:`Không tìm thấy function name:  '${key}'`}}}
    return store.state.endpoint.endPointConfig[key]
  }
}
